export const fetchSale = async uuid => {
  return await window.$vue.$get({ endpoint: `/sale/${uuid}` })
}

export const startSale = async data => {
  return await window.$vue.$post({
    endpoint: "/sale/request",
    data
  })
}

export const saveSale = async data => {
  return await window.$vue.$post({ endpoint: "/sale", data })
}

export const editSale = async (id, data) => {
  return await window.$vue.$put({ endpoint: `/sale/${id}`, data })
}

export const saveSaleProperties = async ({ id, data }) => {
  return await window.$vue.$put({
    endpoint: `/sale/${id}/request-properties`,
    data
  })
}

export const ratingSale = async data => {
  return await window.$vue.$post({ endpoint: "/enps", data })
}

export const searchInProgressSale = async document => {
  return await window.$vue.$get({
    endpoint: `/sale/${document}/search-in-progress`
  })
}

export const fetchSaleFlows = async document => {
  return await window.$vue.$get({
    endpoint: `/sale-flow/list-sale`
  })
}

export const fetchChainOptions = () =>
  window.$vue.$get({ endpoint: "/chain/list-all" })

export const fetchPosOptions = (params = {}) =>
  window.$vue.$get({ endpoint: "/pos/list-all", params })

export const fetchSellerByPos = async uuid =>
  window.$vue.$get({ endpoint: `/user/find-seller-by-pos/${uuid}` })

export const updateSale = async (uuid, data) =>
  window.$vue.$put({ endpoint: `/sale/${uuid}/registration-data`, data })
